// src/pages/EstoquePage/EstoquePage.jsx
import React, { useState } from "react";
import UploadNotaXML from "features/estoque/components/UploadNotaXML";
import ListaEstoque from "features/estoque/components/ListaEstoque";
import DashboardEstoque from "features/estoque/components/DashboardEstoque";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "components/ui/tabs";
import { BarChart3, FileText, Package } from "lucide-react";

const EstoquePage = () => {
  // Define "indicadores" como a aba principal padrão
  const [tabAtiva, setTabAtiva] = useState("indicadores");

  return (
    <div className="flex flex-col gap-4 max-w-7xl mx-auto w-full px-1 sm:px-4">
      {/* Cabeçalho Executivo */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-b border-slate-200 dark:border-slate-800 pb-3">
        <div>
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100 flex items-center gap-2">
            <span>Controle de Estoque & Notas Fiscais</span>
          </h1>
          <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
            Visão consolidada de compras, vendas, sincronização SEFAZ e controle físico de bar.
          </p>
        </div>
      </div>

      {/* Navegação por Abas Principais com Indicadores em Destaque */}
      <Tabs value={tabAtiva} onValueChange={setTabAtiva} className="w-full space-y-3">
        <TabsList className="grid grid-cols-3 w-full max-w-xl bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 p-1 rounded-xl h-10">
          <TabsTrigger
            value="indicadores"
            className="flex items-center justify-center gap-1.5 text-xs font-semibold data-[state=active]:bg-emerald-600 data-[state=active]:text-white rounded-lg transition-all shadow-none"
          >
            <BarChart3 className="w-3.5 h-3.5" />
            <span className="truncate">Indicadores</span>
          </TabsTrigger>

          <TabsTrigger
            value="fila"
            className="flex items-center justify-center gap-1.5 text-xs font-semibold data-[state=active]:bg-emerald-600 data-[state=active]:text-white rounded-lg transition-all shadow-none"
          >
            <FileText className="w-3.5 h-3.5" />
            <span className="truncate">Entrada & Notas</span>
          </TabsTrigger>

          <TabsTrigger
            value="estoque"
            className="flex items-center justify-center gap-1.5 text-xs font-semibold data-[state=active]:bg-emerald-600 data-[state=active]:text-white rounded-lg transition-all shadow-none"
          >
            <Package className="w-3.5 h-3.5" />
            <span className="truncate">Estoque Físico</span>
          </TabsTrigger>
        </TabsList>

        {/* ABA 1 (PRINCIPAL): INDICADORES FINANCEIROS DE COMPRAS E VENDAS */}
        <TabsContent value="indicadores" className="space-y-4 focus-visible:outline-none">
          <DashboardEstoque defaultMostrarGrafico={true} />
        </TabsContent>

        {/* ABA 2: ENTRADA DE NOTAS, FILA SEFAZ & UPLOAD */}
        <TabsContent value="fila" className="space-y-4 focus-visible:outline-none">
          <UploadNotaXML />
        </TabsContent>

        {/* ABA 3: ESTOQUE FÍSICO & PRODUTOS */}
        <TabsContent value="estoque" className="space-y-4 focus-visible:outline-none">
          <ListaEstoque />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EstoquePage;
